import React, { Component } from 'react';
import Grid from '../../Utils/GridProduccionA';
import { standardActions } from '../../Utils/GridProduccionA/StandardActions';
import moment from 'moment';

class DetalleDatosFamiliares extends Component{
    
    render(){
        const { loader, detalle, eliminarLinea } = this.props;
        return(
            <React.Fragment>
                {detalle &&
                <Grid 
                    hover 
                    striped 
                    data={detalle} 
                    loading={loader}
                    headerStyle={ { background: 'black' } } 
                >
                    <TableHeaderColumn
                        isKey
                        dataField="nombre"
                        dataAlign='left'
                        width="300"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Nombre
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="genero"
                        headerAlign="center"
                        dataAlign='center'
                        width="100"
                        dataFormat={(cell, row)=>{
                            if (cell === 'H'){
                                return 'Hombre';
                            }else{
                                return 'Mujer';
                            }
                            
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                        >
                        Género
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fecha_nacimiento"
                        headerAlign="center"
                        dataAlign='right'
                        width="100"
                        dataSort
                        dataFormat={(cell, row)=>{
                            return moment(cell).format("DD/MM/YYYY");
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                        >
                        Fecha de nacimiento
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="edad"
                        dataAlign='right'
                        width="100"
                        headerAlign="center"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Edad
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        thStyle={
                        {color: 'white'}}
                        dataField="id"
                        width="100"
                        dataAlign="center"
                        dataSort
                        dataFormat={standardActions({
                        eliminar: eliminarLinea })} 
                    >
                        Acciones
                    </TableHeaderColumn>
                </Grid>
                }
            </React.Fragment>
        );
    }
}

export default DetalleDatosFamiliares;

